import { StrictMode, type ReactElement } from "react";
import { createRoot } from "react-dom/client";

import { getHTMLAppProps } from "../phpHelpers.js";
import { AppContextProvider } from "../shared/AppContextProvider.js";
import type { AppProps } from "../types.js";
import { WhatSizeDoINeed } from "./page.js";

/**
 * Loads the what sizes page into the provided container.
 *
 * @param container The container to load into.
 */
export function mountWhatSize(container: HTMLDivElement): void {
	const root = createRoot(container);
	const htmlAppProps = getHTMLAppProps(container);
	root.render(
		<StrictMode>
			<WhatSize {...htmlAppProps} />
		</StrictMode>,
	);
}

/**
 * The root of the What Size Do I Need? component.
 *
 * @param props The app data from the parent container.
 * @returns The component.
 */
export function WhatSize(props: AppProps): ReactElement {
	return (
		<AppContextProvider {...props}>
			<WhatSizeDoINeed />
		</AppContextProvider>
	);
}
